module.exports = __webpack_public_path__ + "img/4.7bb50425.png";